"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoredRemoteConfigProvider = void 0;
const StoredRemoteConfigProvider = (props) => {
    const { provider, key, storage } = props;
    const getRemoteConfigKey = (id) => {
        return key + id;
    };
    const getRemoteConfig = async (id) => {
        const configKey = getRemoteConfigKey(id);
        const storedJson = storage.getItem(configKey);
        if (storedJson) {
            try {
                const parsedConfig = JSON.parse(storedJson || '');
                // check if object is RemoteConfig
                if (parsedConfig.type) {
                    return parsedConfig;
                }
            }
            catch (error) {
                throw error;
            }
        }
        storage.removeItem(configKey);
        const config = await provider.getRemoteConfig(id);
        const json = JSON.stringify(config);
        storage.setItem(configKey, json);
        return config;
    };
    return {
        getRemoteConfig,
    };
};
exports.StoredRemoteConfigProvider = StoredRemoteConfigProvider;
